(() => {
  const syncLanguageMarket = () => {
    const form = document.getElementById('LandeHeaderLanguage');
    const market = form?.querySelector('[data-language-market]');
    if (!market || market.dataset.designMode === 'true') return;
    const target = market.dataset.language === 'en' ? 'US' : market.dataset.language === 'fr' ? 'FR' : null;
    if (!target || market.dataset.country === target || !market.querySelector(`[data-country-code="${target}"]`)) return;
    // Native localization converts every Shopify price, including the existing bag.
    // One attempt per language/country prevents a loop if Shopify rejects a market.
    const key = `lande-market:${market.dataset.language}:${market.dataset.country}`;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch (_) { return; }
    form.querySelector('[data-language-country]').value = target;
    form.submit();
  };
  const sync = () => {
    document.documentElement.style.setProperty('--lande-annonce-h', '0px');
    const header = document.querySelector('.lande-entete');
    if (header) { header.style.top = '0px'; header.setAttribute('data-hidden', 'false'); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { sync(); syncLanguageMarket(); }); else { sync(); syncLanguageMarket(); }
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('click',e=>{if(e.target.closest('.lande-mobile-menu a'))document.querySelector('.lande-mobile-menu')?.removeAttribute('open');});
  document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelector('.lande-mobile-menu')?.removeAttribute('open');});
})();
